<template>
  <svg version="1.1"
       id="Layer_1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
       x="0px"
       y="0px"
       viewBox="0 0 2500 2500"
       :width="width"
       :height="height"

       style="enable-background:new 0 0 2500 2500;"
       xml:space="preserve"
  >
    <a xlink:href="https://www.linkedin.com/company/impact-imaging-group-llc"
       target="_blank">
    <path class="st0" d="M0,183.4C0,84.9,82.4,5,184,5H2306c101.6,0,184,79.9,184,178.4v2133.3c0,98.5-82.4,178.3-184,178.3H184 c-101.6,0-184-79.8-184-178.3V183.4L0,183.4z"/>
    <path class="st1" d="M756.7,2088.8v-1121H384.1v1121H756.7L756.7,2088.8z M570.5,814.8c129.9,0,210.8-86.1,210.8-193.7 c-2.4-110-80.9-193.7-208.3-193.7c-127.5,0-210.8,83.7-210.8,193.7c0,107.6,80.8,193.7,205.9,193.7L570.5,814.8L570.5,814.8z M962.9,2088.8h372.6v-626c0-33.5,2.4-67,12.3-90.9c26.9-67,88.2-136.3,191.2-136.3c134.8,0,188.7,102.8,188.7,253.5v599.6h372.6V1446c0-344.3-183.8-504.5-428.9-504.5c-201,0-289.2,112.3-338.3,188.8h2.5V967.8H962.9C967.8,1073,962.9,2088.8,962.9,2088.8 L962.9,2088.8z"/>
    </a>
</svg>

</template>

<script>
export default {
  name: "LinkedIn",
  props: {
    width: String,
    height: String,
  }
}
</script>

<style lang="scss">
  .st0{
    fill:#FFFFFF;
  }
  .st1{
    fill:#231F20;
    fill-opacity: 100%;
  }
</style>